import clsx from 'clsx';
import { useIntl } from 'react-intl';

import { useFilterFieldContext } from '../hooks/useFilterFieldContext.js';
import { filterFieldMessages } from '../messages.js';
import { defaultSuggestion, searchSuggestion } from './Suggestion.sty.js';
import { Suggestion } from './Suggestion.js';
import { SuggestionGroup } from './SuggestionGroup.js';

/**
 * @internal
 */
export function SearchSuggestionGroup() {
  const { searchSuggestionValues } = useFilterFieldContext();
  const intl = useIntl();

  if (searchSuggestionValues.length === 0) {
    return null;
  }

  return (
    <SuggestionGroup
      aria-label={intl.formatMessage(
        filterFieldMessages.suggestions.a11y.search,
      )}
    >
      {searchSuggestionValues?.map((suggestion, index) => (
        <Suggestion
          {...suggestion}
          key={suggestion.value ?? index}
          className={clsx(defaultSuggestion, searchSuggestion)}
          data-strato-filter-field-virtual-focus-type="search-suggestion"
        />
      ))}
    </SuggestionGroup>
  );
}
